import { useState, useEffect } from "react";
import axios from "axios";

export default function MailSettings() {
  const [settings, setSettings] = useState({
    host: "",
    port: 587,
    secure: false,
    user: "",
    pass: "",
    from: "",
    name: ""
  });

  useEffect(() => {
    axios.get("/mail/settings")
      .then(res => setSettings(res.data))
      .catch(() => {});
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSettings(prev => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
  };

  const handleSave = () => {
    axios.post("/mail/settings", settings)
      .then(() => alert("✅ Configuración guardada"))
      .catch(() => alert("❌ Error guardando configuración"));
  };

  return (
    <div className="p-4">
      <h2 className="text-lg font-bold mb-4">Configuración SMTP</h2>
      <input className="border p-2 mb-2 w-full" placeholder="Host SMTP" name="host" value={settings.host} onChange={handleChange} />
      <input className="border p-2 mb-2 w-full" placeholder="Puerto" type="number" name="port" value={settings.port} onChange={handleChange} />
      <label className="block mb-2">
        <input type="checkbox" name="secure" checked={settings.secure} onChange={handleChange} /> Usar conexión segura (SSL/TLS)
      </label>
      <input className="border p-2 mb-2 w-full" placeholder="Usuario" name="user" value={settings.user} onChange={handleChange} />
      <input className="border p-2 mb-2 w-full" placeholder="Contraseña" type="password" name="pass" value={settings.pass} onChange={handleChange} />
      <input className="border p-2 mb-2 w-full" placeholder="Correo remitente" name="from" value={settings.from} onChange={handleChange} />
      <input className="border p-2 mb-4 w-full" placeholder="Nombre remitente" name="name" value={settings.name} onChange={handleChange} />
      <button onClick={handleSave} className="bg-blue-500 text-white px-4 py-2 rounded">Guardar</button>
    </div>
  );
}
